module.exports = __webpack_public_path__ + "assets/media/september-1@2x.8a256ad1.png";